//=============================================================================
// Contents   : HRDB
//              従業員情報全項目編集
//              UpdAllItem
// Author     : RV上田
// LastUpdate : 2022/12/7
// Since      : 2022/12/7
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */

/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useForm,useFieldArray } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';
import { useProvideData } from "03CommonApiParts/use-context";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { Table } from "02CommonUiParts/TableParts/Table";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { Title } from "01Pages/Common/UiParts/Title";

/* ====== Style ====== */
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { TableArray } from "02CommonUiParts/TableParts/TableArray";
import { InputErrorMessage } from "02CommonUiParts/TableParts/InputErrorMessage";
import styled from "styled-components";
import { CFArrayFount, CFJsonIgnore, CFSort, CFStringDecodeJP, CFStringEncodeJP, checkChangeFlag, confirmChange } from "03CommonApiParts/CommonFunction";
import { screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";
import { AllItemConfig } from "./TableConfig";

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ====== Styled Components ====== */
const SdivFlex = styled.div`
	display: flex;
	gap: 10px;
`
const SdivLeft = styled.div`
	min-width: min-content;
	/* width: 50%; */
	/* margin-right: 20px; */
`
/* ------ページコンテンツ ------*/

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */
const CommonStyle = StyleCommon();//共通スタイルドコンポーネント
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ
/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */

/* ========= 人事稟議情報編集 ========= */
export const UpdAllItem = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const location = useLocation();
    const apiData = useProvideData();//APIデータ取得

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
	const { register, getValues, setValue, handleSubmit, control,  setError, clearErrors, watch,formState: { errors } } = useForm({
		mode: 'onBlur',
		reValidateMode: 'onChange',
		shouldUseNativeValidation: false,
		shouldUnregister: false
	});

	// setValue('payload.a', true)
	// setValue('payload.b', true)
	// setValue('payload.c', true)

	/* ====== useFieldArrayを定義 ====== */
	const { fields, move, update, replace} = useFieldArray(
		{
			control,
			name: "payload4.list"
		}
	);

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
	const dataOtpId = location.state.dataOtpId;
    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 


    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
	const [master, setMaseter] = useState({})//マスタ格納用
	const [employmentStatusList, setEmploymentStatusList] = useState([]);
	const [pageMode, setPageMode] = useState('edit');//ページモードを管理
	const [dataRow, setDataRow] = useState({});//データ格納用
	const [confirm, setConfirm] = useState({});//確認用データ格納用
    const [newData, setNewData] = useState([]);//変更後データ格納用
	const [dragIndex, setDragIndex] = useState();
	const [disabledDep, setDisabledDep] = useState(true)
	
    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */
    
    useEffect(() => {
		
		initialFunction();
		// 部署の設定
		// const busyoCheck = getValues('payload1.check')
		// setDisabledDep(busyoCheck === 'all')
		

    // eslint-disable-next-line
    },[]);
	/* ====== 初期処理 ====== */ 
	const initialFunction = () =>{
		/* プログレスバー表示 */
		setProgress(true);
		/* マスタデータ取得 */
		getMaster();
	}
	/* ====== マスタの取得処理 ====== */
    const getMaster = async() => {
        /* リクエスト先 */
        const apiPath = '/search/getmaster';
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* キー */
        key.aplySrtDate = null;
        key.mstList = ['employmentStatusMaster','departmentMaster','fullOutputItemMaster'];//雇用形態・部署・全出力項目

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
				const dataEdit = {};
				// data.forEach((item)=>{
				// 	dataEdit[item.code] = item;
				// })
				data.forEach((item)=>{
                    const object = {};
                    const list = [];
                    item.list.forEach((element)=>{
                        list.push({
                            value:element.value,
                            label:CFStringDecodeJP(element.label,base64Swicth)
                        });
                    })
                    object.code = item.code;
                    object.name = CFStringDecodeJP(item.name,base64Swicth);
                    object.list = list;
					dataEdit[item.code] = object;
                })
				setMaseter(dataEdit);
				const editEmploymentStatusList = [];
				dataEdit.employmentStatusMaster.list.forEach((item,index)=>{
					editEmploymentStatusList.push(
						{
							name:item.value,
							type:'checkbox',
							title:item.label,
							onChange:leftTableOnChange
						}
					);
					if(dataEdit.employmentStatusMaster.list.length - 1 === index){
						editEmploymentStatusList.push(
							{ 
								name:'error',
								type:'error', 
								style: {marginTop: '-15px'}
							}
						);
					}
				});
				setEmploymentStatusList(editEmploymentStatusList);

				/* 詳細情報の取得 */
				getData(dataEdit);
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };
    /* ====== APIからデータ取得 ====== */
	const getData = async (masterData) => {
		/* リクエスト先 */
		const apiPath = '/employee/getdetailoutputall';	//API Path

		/* リクエスト*/
		const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
		
		/* キー */
		key.dataOtpId = dataOtpId;

		/* リクエストパラメータ */
		const apiBody = {handlingInformation:handlingInformation, key:key};

		/* API処理開始 */
		await apiData.getDataPost(apiPath, apiBody, (result) => {
			/* プログレスバー非表示 */
			setProgress(false);
			if (result.isSuccessed) {//APIリクエスト結果 = 正常
				
			/* データ編集用配列 */
				const data = result.responseData.data.payload;
				const payload1 = {};
				const payload2 = {};
				const payload3 = {};
				var payload4 = [];
				/* 出力名 */
				payload1.dataOtpName = CFStringDecodeJP(data.dataOtpName,base64Swicth);
				/* 雇用形態 コード定義と一致する場合はtrue */
				data.empiSttsCd.forEach((item)=>{
					payload2[`${item}`] = true;
				});
				/* 部署 */
				payload3.etrDptTrgCd = data.etrDptTrgCd;
				payload3.department1 = data.dptCd[0] ? `${data.dptCd[0]} ${CFStringDecodeJP(data.dptName[0],base64Swicth)}`:'';
				payload3.department2 = data.dptCd[1] ? `${data.dptCd[1]} ${CFStringDecodeJP(data.dptName[1],base64Swicth)}`:'';
				payload3.department3 = data.dptCd[2] ? `${data.dptCd[2]} ${CFStringDecodeJP(data.dptName[2],base64Swicth)}`:'';
				payload3.department4 = data.dptCd[3] ? `${data.dptCd[3]} ${CFStringDecodeJP(data.dptName[3],base64Swicth)}`:'';

				/* 部署のラジオボタンの項目がallDepartmentならdisable */
				data.etrDptTrgCd === 'allDepartment' ? setDisabledDep(true) : setDisabledDep(false);
				/* 項目選択 */
				masterData.fullOutputItemMaster.list.forEach((item,i)=>{
					const num = data.itemCd.findIndex(e=>e === item.value);
					if(num === -1){
						payload4.push({
							number:'ー',
							outputTargetId:item.value,
							outputTargetLabel:item.label,
							outputTarget:false
						})
					}else{
						payload4.push({
							number: num + 1,
							outputTargetId:item.value,
							outputTargetLabel:item.label,
							outputTarget:true
						})
					}

				});
				/* outputTargetでソートした後にnumberでソート */
				payload4 = CFSort(payload4,'desc','outputTarget');
				payload4 = CFSort(payload4,'asc','number');

				const payload4Edit = [];
				payload4.forEach((row,i)=>{
					payload4Edit.push({...row,id:i})
				})
				setValue('payload4.list',payload4Edit);
				setDataRow({
					payload1:payload1,
					payload2:payload2,
					payload3:payload3,
					payload4:payload4Edit
				});
				/* 画面表示開始 */
				setLoading(true);

			}else{//APIリクエスト結果 = 異常

			    /* スナックバー表示 */
			    setSnackbarMessage({      
			        ...snackbarMessage,
			        open:true,
			        message:result,//APIによるエラー
			        $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
			        type: 1,//APIエラー時:1,それ以外:2 
			        level:'error',//エラースナックバー
			    })
			}
		});
	};
	/* ====== 完了ボタン押下時の処理 ====== */
    const onClickCenter = async() => {
		/* ページモードがeditなら削除処理 */
		if(pageMode === 'deleteConfirm'){
			/* プログレスバー表示 */
			setProgress(true);
			/* リクエスト先 */
			const apiPath = '/employee/deleteoutputall';	//API Path

			/* リクエスト*/
			const handlingInformation = {};
			const key = {};
			/* 操作情報 */
			handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
			handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
			handlingInformation.sreId = screenId;
			handlingInformation.hndId = 'DELETE';
			
			/* キー */
			key.dataOtpId = dataOtpId;

			/* リクエストパラメータ */
			const apiBody = {handlingInformation:handlingInformation, key:key};
			/* API処理開始 */
			await apiData.getDataPost(apiPath, apiBody, (result) => {
				/* プログレスバー非表示 */
				setProgress(false);
				if (result.isSuccessed) {//APIリクエスト結果 = 正常
					navigate('/common/completion', {
						state:{
							title: '従業員全項目削除完了', 
							message: screenDisplayMessage('CMNI005'), //データの削除完了
							button:[
								{name: '一覧画面へ戻る', path:'/employee/allitem/list'},
							]
							},
						replace:true
					},);
				}else{//APIリクエスト結果 = 異常

					/* スナックバー表示 */
					setSnackbarMessage({      
						...snackbarMessage,
						open:true,
						message:result,//APIによるエラー
						$1:result.responseData ? result.responseData.data.metadata: '',//取得件数
						type: 1,//APIエラー時:1,それ以外:2 
						level:'error',//エラースナックバー
					})
				}
			});
		}
		/* ページモードがconfirmなら更新処理 */
		else{
			/* プログレスバー表示 */
			setProgress(true);
			/* リクエスト先 */
			const apiPath = '/employee/updateoutputall';	//API Path
			/* リクエスト*/
			const handlingInformation = {};
			const key = {};
			const payload = {};
			/* 操作情報 */
			handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
			handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
			handlingInformation.sreId = screenId;
			handlingInformation.hndId = 'UPDATE';
			
			/* キー */
			key.dataOtpId = dataOtpId;

			/* payload */
			payload.dataOtpName = CFStringEncodeJP(newData.payload1.dataOtpName,base64Swicth);//データ出力名
			payload.empiSttsCd = [];//雇用形態コード
			master.employmentStatusMaster.list.forEach((item)=>{
				if(newData.payload2[item.value]){
					payload.empiSttsCd.push(item.value);
				}
			});
			payload.etrDptTrgCd = newData.payload3.etrDptTrgCd;//抽出部署対象コード
			const deptConts = ['department1','department2','department3','department4'];
			const dptCd = [];//部署コード
			deptConts.forEach((item)=>{
				if(newData.payload3[item]){
					dptCd.push(newData.payload3[item].split(' ')[0]);
				};
			});
			payload.dptCd = dptCd;
			payload.itemCd = [];//項目コード
			if(Array.isArray(newData.payload4)){
				newData.payload4.forEach((item)=>{
					if(item.outputTarget){
						payload.itemCd.push(item.outputTargetId)
					};
				});
			}else{
				newData.payload4.list.forEach((item)=>{
					if(item.outputTarget){
						payload.itemCd.push(item.outputTargetId)
					};
				});
			};
			/* リクエストパラメータ */
			const apiBody = { handlingInformation:handlingInformation, key:key, payload:payload };
			/* API処理開始 */
			await apiData.getDataPost(apiPath, apiBody, (result) => {
				/* プログレスバー非表示 */
				setProgress(false);
				if (result.isSuccessed) {//APIリクエスト結果 = 正常
					navigate('/common/completion', {
						state:{
							title: '従業員全項目編集完了', 
							message: screenDisplayMessage('CMNI004'), //データの更新が完了しました。
							button:[
								{name: '一覧画面へ戻る', path:'/employee/allitem/list'},
								{name: '編集画面へ戻る', path:'/employee/allitem/update',state:{dataOtpId:dataOtpId}},
							]
							},
						replace:true
					},);
				}else{//APIリクエスト結果 = 異常
					/* スナックバー表示 */
					setSnackbarMessage({      
						...snackbarMessage,
						open:true,
						message:result,//APIによるエラー
						type: 1,//APIエラー時:1,それ以外:2 
						level:'error',//エラースナックバー
					})
				};
			});


		}
        

    };
	/* ====== 戻る・キャンセルボタン押した時の処理 ====== */
	const onClickLeft = () => {
		/* modeがeditなら前の画面に戻る */
		if(pageMode === 'edit'){
			navigate('/employee/allitem/list')
		}else{
			/* それ以外なら編集モードに戻す */
			setPageMode('edit');
			setValue('payload1',newData.payload1);
			setValue('payload2',newData.payload2);
			setValue('payload3',newData.payload3);
			setValue('payload4.list',newData.payload4.list ? newData.payload4.list : newData.payload4);
			setConfirm({});
		}
		
	};
	/* ====== 削除ボタンを押した時の処理 ====== */
	const onClickRight = () => {
		/* 変更後のデータをnewDataに入れておく */
		setNewData({
			payload1:getValues('payload1'),
			payload2:getValues('payload2'),
			payload3:getValues('payload3'),
			payload4:getValues('payload4.list')
		})
		/* deleteモードに変更 */
		setPageMode('deleteConfirm');
		/* dataRowにリセット */
		setValue('payload1',dataRow.payload1)
		setValue('payload2',dataRow.payload2)
		setValue('payload3',dataRow.payload3)
		setValue('payload4.list',dataRow.payload4);
	};
	
    /* ====== 確認ボタン押下後、バリデーションが正しく通った場合 ====== */
    const onClickSubmit = (data) => {
		/* 雇用形態のデータ形の修正 */
		const dataPayload2edit = {};
		const dataRowPaylod2Edit = {};
		master.employmentStatusMaster.list.forEach((item)=>{
			if(data.payload2[item.value]){
				dataPayload2edit[item.value] = true;
			}else{
				dataPayload2edit[item.value] = false;
			};
			if(dataRow.payload2[item.value]){
				dataRowPaylod2Edit[item.value] = true;
			}else{
				dataRowPaylod2Edit[item.value] = false;
			}
		});
		/* 修正した値をセットし直す */
		dataRow.payload2 = dataRowPaylod2Edit;
		data.payload2 = dataPayload2edit;


		/* 出力項目のデータの修正 */
		const editPayload4 = [];
		data.payload4.list.forEach((row,i)=>{
			/* 変更データに合わせて、dataRowのデータも並べ替える　*/
			editPayload4.push(dataRow.payload4.find((item)=>item.outputTargetId === row.outputTargetId));
		});
		/* dataRowにセットし直す*/
		dataRow.payload4 = editPayload4;
	
		delete dataRow.tableCheck;
		const oldData = {
			payload1:dataRow.payload1,
			payload2:dataRow.payload2,
			payload3:dataRow.payload3,
			payload4:dataRow.payload4
		};
		const newData = {
			payload1:data.payload1,
			payload2:data.payload2,
			payload3:data.payload3,
			payload4:data.payload4.list
		}
		// console.log(dataRow,data)
		/* 変更点がない場合　*/
		if(CFJsonIgnore(oldData) === CFJsonIgnore(newData)){
			/* スナックバー表示 */
            setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW004',
                type: 2,//APIエラー時:1,それ以外:2 
            });
		}else{
		/* 変更点がある場合　*/
			/* 変更があればchangeFlagをtrueにする */
			let changeFlags = {};
			changeFlags.payload1 = checkChangeFlag(dataRow.payload1,data.payload1,Object.keys(data.payload1));
			changeFlags.payload2 = checkChangeFlag(dataRow.payload2,data.payload2,Object.keys(data.payload2));
			changeFlags.payload3 = checkChangeFlag(dataRow.payload3,data.payload3,Object.keys(data.payload3));
			changeFlags.payload4 = checkChangeFlag(dataRow.payload4,data.payload4.list,Object.keys(data.payload4.list[0]));
			const payload1 = confirmChange(changeFlags.payload1,dataRow.payload1,data.payload1,Object.keys(data.payload1));
			const payload2 = confirmChange(changeFlags.payload2,dataRow.payload2,data.payload2,Object.keys(data.payload2));
			const payload3 = confirmChange(changeFlags.payload3,dataRow.payload3,data.payload3,Object.keys(data.payload3));

			const payload4 = confirmChange(changeFlags.payload4,dataRow.payload4,data.payload4.list,Object.keys(data.payload4.list[0]));
            /* 確認用データの格納 */
			setConfirm(
                {
                    flags:changeFlags,
                    payload1:payload1,
                    payload2:payload2,
                    payload3:payload3,
                    payload4:payload4,
                }
            );
            /* 変更後データの格納 */
            setNewData(data);
			/* dataRowにリセット */
			setValue('payload1',dataRow.payload1)
			setValue('payload2',dataRow.payload2)
			setValue('payload3',dataRow.payload3)
			setValue('payload4.list',dataRow.payload4);
			/* 確認モードに変更　*/
			setPageMode('updateConfirm');
		};
    };
	/* ====== 雇用形態のバリデーション ====== */
	const leftTableOnChange = () => {
		const data = getValues('payload2')
		if (Object.values(data).filter(Boolean).length === 0) {
			setError('payload2.error',{type:'custom',message:'必須'})
		} else {
			clearErrors('payload2.error');
		}
	};

    /* ===　全チェックした時の処理　=== */
	const onClickAllCheck = (event) => {
		const newFields = fields.map((field, index) => (
			event.target.checked === true
				? {...field, outputTarget: true,number: index + 1}//チェック時は全てチェックと番号を振って置き換え
				: {...field, outputTarget: false, number: 'ー'}//チェックアウト時はチェックと番号を外して置き換え
		))
		replace(newFields);
	};
	/* === ドラッグ開始処理 === */
	const dragStart = (event,index) =>{
		setDragIndex(index);
		event.dataTransfer.effectAllowed = "move";
	}
	 /* === ドラッグ中処理 === */
	const dragEnter = (index) =>{
		
	}
	/* === ドラッグ終了処理 === */
	const dragEnd = (index) => {
		/* 同じ場所にドロップしている時は何もしない */
		if(index === dragIndex) return;
		/* falseの場所にドロップしたら何もしない */
		var falseIndex = fields.findIndex((row) => row.outputTarget === false);
		
		if(falseIndex === -1){
			move(dragIndex,index);
			const data = getValues('payload4.list');
			const editData = [...data];
			data.forEach((row,index)=>{
				if(row.outputTarget){
					editData[index].number = index + 1;
				};
			});
		}else if(index >= falseIndex){
			/* 何もしない　*/
		}else{
			move(dragIndex,index);
			const data = getValues('payload4.list');
			const editData = [...data];
			data.forEach((row,index)=>{
				if(row.outputTarget){
					editData[index].number = index + 1;
				};
			});
		}
		
		
	}

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
	/* 従業員全項目系で使うデータが入っているconfigをセット */
	const config = AllItemConfig(master,getValues,setValue,setError,clearErrors,disabledDep,setDisabledDep,employmentStatusList,fields,move);

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };

	
    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバーの表示 */}
            <LoadingProgressBar open={progress}/>
			{dataRow.payload1 ?
				<>
					{/* 画面タイトル */}
					<Title text='従業員情報全項目編集'/>
					{/* 確認文言 */}
					<CommonStyle.GdivConfirmText mode={pageMode}/>
					{/* <Table /> */}
					<CommonStyle.GdivPageContentsWrapper >
						{/* ページコンテンツ */}
						<form onSubmit={handleSubmit(onClickSubmit)}>
							<div>
								<SdivLeft>
									{/* 問合せ情報テーブル */}
									<div>
										<CommonStyle.GdivSubTitleWrapper>
											出力名
										</CommonStyle.GdivSubTitleWrapper>
										{/* 問合せ情報テーブル */}
										<LeftTitleTable
											className='baseText'
											register={register}
											payload='payload1'
											errors={errors}
											dataRow={confirm.payload1? confirm.payload1 : dataRow.payload1}
											tableConfig={pageMode === 'edit' ? config.outputNameTableConfig : config.cnfOutputNameTableConfig}
											changeFlags={confirm?.flags?.payload1}
											payloadData={watch('payload1')} //ここはwatchを使わないと取れない
											getValues={getValues}
										/>
									</div>
									<div>
										<CommonStyle.GdivSubTitleWrapper>
											抽出条件
										</CommonStyle.GdivSubTitleWrapper>
										<SdivFlex>
											<LeftTitleTable
												className='baseText'
												register={register}
												payload='payload2'
												errors={errors}
												dataRow={confirm.payload2 ? confirm.payload2 : dataRow.payload2}
												tableConfig={pageMode === 'edit' ? config.empiSttsTableConfig : config.cnfEmpiSttsTableConfig}
												changeFlags={confirm?.flags?.payload2}
												payloadData={getValues('payload2')}
											/>
											<LeftTitleTable
												className='baseText'
												register={register}
												payload='payload3'
												errors={errors}
												dataRow={confirm.payload3 ? confirm.payload3 : dataRow.payload3}
												tableConfig={pageMode === 'edit' ? config.deptTableConfig : config.cnfDeptTableConfig}
												width={'400px'}
												changeFlags={confirm?.flags?.payload3}
												payloadData={getValues('payload3')}
											/>
										</SdivFlex>
									</div>
								</SdivLeft> 
								<div>
									<CommonStyle.GdivSubTitleWrapper>
										項目選択
										{errors?.payload4?.error && <InputErrorMessage errorMessage={errors.payload4.error.message} style={{fontWeight: 'initial'}}/>}
									</CommonStyle.GdivSubTitleWrapper>
									{pageMode !== 'updateConfirm'?
										<TableArray
										paperStyle={
											{ maxHeight: 'calc(100vh - 170px)' }
										}//{ maxHeight: assets().size.tableHeightsize }
										errors={errors}
										fieldsList={fields}
										payload='payload4'
										register={register}
										headCells={pageMode === 'edit' ? config.chooseItemHeadData : config.cnfChooseItemHeadData} //ヘッダの設定情報
										bodyCells={pageMode === 'edit' ? config.chooseItemBodyData : config.cnfChooseItemBodyData} //ボディの設定情報
										dataRow={dataRow.payload4}
										payloadCategory={'list'}
										payloadData={watch('payload4.list')}
										tableType='moveOnlyChecked'
										editMode={true}
										inputMargin={true}
										getValues={getValues}
										setValue={setValue}
										update={update}
										hoverEffect={true}
										onClickAllCheck={onClickAllCheck}
										dragStart={dragStart}
										dragEnter={dragEnter}
										dragEnd={dragEnd}
										// onClickBodyRow={onClickBodyRow}
										/>
										:
										<Table
										headCells={config.cnfChooseItemHeadData} //ヘッダの設定情報
										bodyCells={config.cnfChooseItemBodyData} //ボディの設定情報
										payload='payload4'
										register={register}
										errors={errors}
										payloadData={getValues('payload4.list')}
										dataRow={confirm.payload4} //表示データ
										notShowSearchNumber={true}
										payloadCategory={'list'}
										changeFlags={confirm?.flags?.payload4}
										/>    
									}
									
								</div>
							</div>
							{/* アンダーバー */}
							<Underbar
								type={pageMode === 'edit' ? 'confirmBackDelete':'completeBack'}//react-hook-form
								onClickLeft={onClickLeft}//戻るボタン押下時の処理
								onClickRight={onClickRight}//戻るボタン押下時の処理
								onClickCenter={onClickCenter}//更新ボタン押下時の処理
							/>
						</form>


					</CommonStyle.GdivPageContentsWrapper>
				</>
				:''
			}
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
            />
                
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */